import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.223 12.259H4.567V4.602h7.656zm.787-9.224H3.783A.78.78 0 0 0 3 3.82v9.223c0 .433.35.786.783.786h9.227c.43 0 .783-.353.783-.786V3.819a.784.784 0 0 0-.783-.784M12.223 25.398H4.567v-7.656h7.656zm.787-9.223H3.783a.78.78 0 0 0-.783.783v9.224c0 .433.35.783.783.783h9.227c.43 0 .783-.35.783-.784v-9.223a.784.784 0 0 0-.783-.783M17.777 4.602h7.656v7.656h-7.656zm8.44 9.226a.785.785 0 0 0 .783-.786V3.819a.78.78 0 0 0-.783-.784h-9.223a.785.785 0 0 0-.787.784v9.223c0 .433.353.786.787.786M24.014 26.576h1.747a.25.25 0 0 0 .25-.25v-7.55a.25.25 0 0 0-.25-.248h-1.747c-.138 0-.25.11-.25.248v7.55c0 .138.112.25.25.25m-3.833 0h1.747a.25.25 0 0 0 .25-.25v-9.31a.25.25 0 0 0-.25-.247H20.18a.25.25 0 0 0-.25.247v9.31c0 .138.112.25.25.25m-3.406 0h1.75a.25.25 0 0 0 .247-.25v-4.491a.25.25 0 0 0-.247-.25h-1.75a.25.25 0 0 0-.247.25v4.491c0 .138.112.25.247.25"
    }, null, -1)
  ]))]))
}
export default { render: render }